module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_6.8a2804bf.png";